/**
 * A card gateway's name for a person - FRONTEND.md §9.793, owner O145; shared since §9.795, because the driver's QR
 * sheet names the page its code opens and the archive names the gateway that took each payment, and two spellings of
 * one name drift.
 *
 * **Each payment keeps the gateway that took it** (`online_payments.gateway`), and after a franchise switches the
 * archive holds both - so the row says which, and the status line names the one new payments go through. A key this
 * function does not know is shown as itself, because the key is what the server sent: a third gateway added on the
 * server reads as its key here rather than as a guess.
 */
export function gatewayName(gateway: string | null | undefined): string {
  if (gateway === 'gpwebpay') return 'GP webpay'
  if (gateway === 'tatrapay' || gateway === null || gateway === undefined || gateway === '') {
    // A row or a settings answer with no gateway predates the column's second value: it is TatraPay's.
    return 'TatraPay+'
  }
  return gateway
}
